import { useQuery, useMutation } from "@tanstack/react-query";
import queryKeys from "libs/react-query/query_key";
import type { UseQueryResult, UseMutationResult } from "@tanstack/react-query";
import {
  POST_verifyVerificationCode,
  POST_sendVerificationCodeToPhone,
  GET_requestForgottenEmail,
  getAccountInfo,
} from "./api_auth";
import type {
  TVerifyVerificationCodeRes,
  TSendVerificationCodeToPhoneRes,
  TRequestForGottenEmailRes,
} from "./auth_types";
import { localStorageKeyToken } from "utils/(localStorage)";
import { useErrorCodeMap } from "libs/react-query/hooks/useErrorCodeMap";

/** POST: 직원 계정 생성 */
export const usePostVerifyVerificationCode = (): UseMutationResult<
  TVerifyVerificationCodeRes,
  unknown,
  { verificationId: string; verificationCode: string },
  unknown
> => {
  const errorCodeMap = useErrorCodeMap();
  return useMutation({
    mutationFn: ({ verificationId, verificationCode }) => POST_verifyVerificationCode(verificationId, verificationCode),
    meta: {
      errorCodeMap,
    },
  });
};

export const usePostSendVerificationCodeToPhone = (): UseMutationResult<
  TSendVerificationCodeToPhoneRes,
  unknown,
  { phoneNumber: string },
  unknown
> => {
  return useMutation({
    mutationFn: ({ phoneNumber }) => POST_sendVerificationCodeToPhone(phoneNumber),
  });
};

export const useGetRequestForGottenEmail = (
  verificationId: string,
  codeVerified: boolean,
): UseQueryResult<TRequestForGottenEmailRes, unknown> => {
  const errorCodeMap = useErrorCodeMap();

  const data = useQuery({
    queryKey: [queryKeys.GET_REQUEST_FORGOTTEN_EMAIL, verificationId],
    queryFn: () => GET_requestForgottenEmail(verificationId),
    enabled: !!verificationId && !!codeVerified,
    meta: {
      errorCodeMap,
    },
  });

  return data;
};

export const useGetAccountInfo = (): UseQueryResult<any, unknown> => {
  const haveToken = !!localStorage.getItem(localStorageKeyToken);

  const data = useQuery({
    queryKey: [queryKeys.GET_MY_ACCOUNT_INFO],
    queryFn: () => getAccountInfo(),
    enabled: haveToken,
  });
  return data;
};
